import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { ServiceDefinition } from '../../../models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'smr-service-definition',
  templateUrl: 'service-definition-item.component.html'
})

export class ServiceDefinitionItemComponent {

  @Input() serviceDefinition: ServiceDefinition;

  @Output() serviceDefinitionSelect = new EventEmitter<ServiceDefinition>();

  constructor () {}

  public onServiceDefinitionSelect () {
    this.serviceDefinitionSelect.emit(this.serviceDefinition);
  }
  
}
